import { Component, type ReactNode } from "react";

interface State { error: Error | null; }

/** Catches render/load errors and shows them on screen instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: unknown) { console.error("App crashed:", error, info); }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: "system-ui, sans-serif", color: "#1A2230", maxWidth: 820, margin: "40px auto" }}>
          <h2 style={{ color: "#B42318", marginBottom: 8 }}>The app failed to load this screen</h2>
          <p style={{ color: "#5B6573" }}>The error below shows exactly what went wrong:</p>
          <pre style={{ background: "#F7F8FA", border: "1px solid #E3E7ED", borderRadius: 8, padding: 14, overflow: "auto", whiteSpace: "pre-wrap", fontSize: 13 }}>
            {this.state.error.message}{"\n\n"}{this.state.error.stack}
          </pre>
          <button onClick={() => location.reload()}
            style={{ marginTop: 12, padding: "9px 18px", background: "#1F3A6E", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
